import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';

interface NewChatState {
  newChatData: any;
  status: boolean;
  error: string | null;
}

const initialState: NewChatState = {
  newChatData: {},
  status: false,
  error: null,
};

const fetchNewChat = createAsyncThunk<any>(
  'newChat/fetchNewChat',
  async (_, thunkAPI) => {
    try {
      const response = await API.get(API_ENDPOINTS.GET_NEW_CHAT);
      return response.data;
    } catch (error: any) {
      return error.response.data;
    }
  }
);

const newChatSlice = createSlice({
  name: 'newChat',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchNewChat.pending, (state: any) => {
        state.status = true;
        state.error = null;
      })
      .addCase(fetchNewChat.fulfilled, (state: any, action: PayloadAction<any>) => {
        state.status = false;
        state.newChatData = action.payload;
      })
      .addCase(fetchNewChat.rejected, (state: any, action: PayloadAction<string>) => {
        state.status = false;
        state.error = action.payload || 'Failed to fetch new chat data';
      });
  },
});

export { fetchNewChat };
export const { reset: newChatReset } = newChatSlice.actions;
export const NewChatReducer = newChatSlice.reducer;
